module.exports = __webpack_public_path__ + "static/media/co-payment-2026.c82ed790.png";